import type { RouteRecordRaw } from 'vue-router';
import ManageChildrenPage from './pages/ManageChildrenPage/ManageChildrenPage.vue';

export const main: RouteRecordRaw[] = [
  {
    name: 'children.manage',
    path: 'children',
    component: ManageChildrenPage,
    meta: {
      requiresAuth: true,
      headerTitle: 'CHILDREN_MANAGEMENT',
    },
  },
];

// export const base: RouteRecordRaw[] = []
